import { render } from "./posDashBoard.vue?vue&type=template&id=4f8c1b94"
import script from "./posDashBoard.vue?vue&type=script&lang=js"
export * from "./posDashBoard.vue?vue&type=script&lang=js"

import "./posDashBoard.vue?vue&type=style&index=0&id=4f8c1b94&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__